import { render, staticRenderFns } from "./draggable-element.vue?vue&type=template&id=9e1d16e8&scoped=true&"
import script from "./draggable-element.vue?vue&type=script&lang=js&"
export * from "./draggable-element.vue?vue&type=script&lang=js&"
import style0 from "./draggable-element.vue?vue&type=style&index=0&id=9e1d16e8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1d16e8",
  null
  
)

export default component.exports